import type { Day1Mode, Day1Phase } from '../../../onboarding/application/resolveDay1Path';

export const HOME_REMOTE_TIMEOUT_MS = 12_000;

export async function withHomeRemoteTimeout<T>(promise: Promise<T>, fallback: T): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    return await Promise.race([
      promise,
      new Promise<T>((resolve) => {
        timer = setTimeout(() => resolve(fallback), HOME_REMOTE_TIMEOUT_MS);
      }),
    ]);
  } finally {
    if (timer) clearTimeout(timer);
  }
}

export function isDay1FreshPhase(phase: Day1Phase | null | undefined): boolean {
  return (
    phase === 'need_catalog' ||
    phase === 'need_cash' ||
    phase === 'need_first_sale' ||
    phase === 'need_first_appointment'
  );
}

/** Día 1 fresh / pre-sync: no cargar stock/compras/agenda (compiten con snapshot de catálogo del POS). */
export function shouldSkipHomeHeavyRemoteLoad(input: {
  mode: Day1Mode | null | undefined;
  phase: Day1Phase | null | undefined;
  /** False mientras SQLite/web cache aún no reflejó un pull de catálogo. */
  catalogHydrated?: boolean;
}): boolean {
  if (input.catalogHydrated === false) return true;
  if (input.mode === 'fresh') return true;
  return isDay1FreshPhase(input.phase);
}

